import { z } from 'zod'
import { PaginationOptionsSchema } from '../types/api/pagination'

export const ErpTempleSchema = z.object({
  ftype: z.string(),
  id: z.number(),
  name: z.string(),
  plc: z.string(),
  qty: z.number(),
  store_qty: z.number(),
  total: z.number(),
  url: z.string(),
})

export const TemplesQuerySchema = z
  .object({
    query: z.string(),
  })
  .extend(PaginationOptionsSchema.shape)

export type TemplesQuery = z.infer<typeof TemplesQuerySchema>
export type ErpTemple = z.infer<typeof ErpTempleSchema>
